const getVariant = nr => {
  if (nr <= 1) return 'danger';
  else if (nr <= 2) return 'warning';
  else if (nr <= 3) return 'secondary';
  else if (nr <= 4) return 'primary';
  else return 'success';
}

export {
  getVariant
}